
        module.exports = __webpack_public_path__ + "assets/images/iceberg.242fccdb.png";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 378,
            height: 378,
            type: "png",
            bytes: 140916,

            toString: function() {
                return src;
            }
        };
    